import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  Grid,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { AdminUserContext } from "contexts/Admin";
import { useContext } from "react";

import { EmailDraft } from "./schema";

interface Props {
  open: boolean;
  close: () => void;
  preview: EmailDraft;
  handleSubmit: () => void;
  testLoading: boolean;
}
const PreviewDialog = ({
  open,
  close,
  preview,
  handleSubmit,
  testLoading,
}: Props) => {
  const context = useContext(AdminUserContext);
  const { currentAdminUser } = {
    ...context,
  };
  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>Preview Email</DialogTitle>

      <DialogContent sx={{ px: 3 }}>
        <FormHelperText sx={{ mb: 1 }}>Subject: </FormHelperText>
        <Box
          sx={{
            border: `1px solid ${grey[300]}`,
            p: 2,
            borderRadius: 2,
            mb: 2,
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: preview.subject }} />
        </Box>

        <FormHelperText sx={{ mb: 1 }}>Body: </FormHelperText>
        <Box sx={{ border: `1px solid ${grey[300]}`, p: 2, borderRadius: 2 }}>
          <div dangerouslySetInnerHTML={{ __html: preview.body }} />
        </Box>

        <Grid container justifyContent="flex-end">
          <FormHelperText sx={{ mt: 3 }}>
            Email will be sent to your admin's email:{" "}
            <strong>{currentAdminUser?.email}</strong>
          </FormHelperText>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ mt: -3, mb: 3, px: 3 }}>
        <Button color="secondary" onClick={close}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          onClick={handleSubmit}
          disableElevation
          loading={testLoading}
        >
          Send Test Email
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewDialog;
